module.exports = __webpack_public_path__ + "static/img/cDR9.dcaa6d4b.png";